/* eslint-disable import/prefer-default-export */
export const COMPANY_CONTACT_TYPES = {
  CONTACT: 'contact',
  INVESTOR: 'investor',
};
